import io from "socket.io-client";
import { API_BASE_URL } from "../../config";
import {
  fetchCoinFlipHistory,
  fetchCoinFlipInvestors,
  fetchCoinFlipLanding,
  fetchCoinFlipPlayers,
  fetchCoinFlipPool,
  setCoinFlipLastSettled,
  setCoinFlipPendingRound,
} from "./coinFlipSlice";

let socket = null;
let initialized = false;

export const initCoinFlipSocket = (dispatch) => {
  if (initialized && socket?.connected) return socket;
  initialized = true;

  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 30000,
      upgrade: false,
      forceNew: false,
      withCredentials: false,
    });
  }

  socket.off("connect");
  socket.off("coin-flip:round:pending");
  socket.off("coin-flip:round:settled");
  socket.off("coin-flip:pool:update");
  socket.off("coin-flip:investors:update");
  socket.off("coin-flip:players:update");

  socket.on("connect", () => {
    dispatch(fetchCoinFlipLanding());
    dispatch(fetchCoinFlipPool());
    dispatch(fetchCoinFlipPlayers({ limit: 100 }));
  });

  socket.on("coin-flip:round:pending", (round) => {
    dispatch(setCoinFlipPendingRound(round));
  });

  socket.on("coin-flip:round:settled", (round) => {
    dispatch(setCoinFlipPendingRound(null));
    dispatch(setCoinFlipLastSettled(round));
    dispatch(fetchCoinFlipPool());
    dispatch(fetchCoinFlipInvestors({ limit: 100 }));
    dispatch(fetchCoinFlipPlayers({ limit: 100 }));
    dispatch(fetchCoinFlipHistory({ limit: 6 }));
  });

  socket.on("coin-flip:pool:update", () => {
    dispatch(fetchCoinFlipPool());
    dispatch(fetchCoinFlipInvestors({ limit: 100 }));
    dispatch(fetchCoinFlipPlayers({ limit: 100 }));
  });

  socket.on("coin-flip:investors:update", () => {
    dispatch(fetchCoinFlipInvestors({ limit: 100 }));
  });

  socket.on("coin-flip:players:update", () => {
    dispatch(fetchCoinFlipPlayers({ limit: 100 }));
  });

  if (!socket.connected) socket.connect();
  dispatch(fetchCoinFlipLanding());
  dispatch(fetchCoinFlipPool());
  dispatch(fetchCoinFlipPlayers({ limit: 100 }));
  return socket;
};
